// TODO(TS) remove if not necessary after rewrite
export var isnan = function(v) {
    return Number.isNaN(v);
};
// TODO(TS) remove if not necessary after rewrite
export var isValidNumber = function(v) {
    return typeof v === "number" && !Number.isNaN(v);
};
export var TEST_MIN_IF_NOT_NAN = function(value, limit) {
    return !isnan(limit) && (limit < 0 && value <= limit || limit >= 0 && value >= limit);
};
export var VEC_LEN_SQ = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_x = _ref.x, x = _ref_x === void 0 ? 0 : _ref_x, _ref_y = _ref.y, y = _ref_y === void 0 ? 0 : _ref_y;
    return x * x + y * y;
};
export var TEST_MAX_IF_NOT_NAN = function(value, max) {
    return !isnan(max) && (max < 0 && value < max || max >= 0 && value > max);
};
export function fireAfterInterval(method, interval) {
    if (!interval) {
        method();
        return null;
    }
    return setTimeout(function() {
        return method();
    }, interval);
}
